import { urlViews } from '@va/constants';
import { getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { LinkIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { URL_VIEW } from '@va/types/website';
import { IconWithBackground, RadioInputSection } from '@va/ui/design-system';
import { useSelector } from 'react-redux';
import useUrlAppearanceCard from './useUrlAppearanceCard';

export const UrlAppearanceCard = () => {
  const translate = useTranslate();

  const { onChange, selectedUrlView } = useUrlAppearanceCard();
  const supportCenterDomain = useSelector(getSupportCenterDomain);
  const isContributor = useSelector(contributorRole);

  return (
    <div className='flex flex-col gap-18px items-start'>
      <SettingsHeading
        title={translate('card.urlAppearence.title')}
        subText={translate('card.urlAppearence.subtitle')}
        tooltip={translate('card.urlView.tooltip', { supportCenterDomain })}
      />
      <div className='flex flex-col gap-4 w-full'>
        <div className='flex flex-col sm-initial:flex-row gap-3'>
          <RadioInputSection
            disabled={isContributor}
            infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
            wrapperClassName='flex-1'
            title={translate('card.urlAppearence.titleView.label')}
            subtitle={translate('card.urlAppearence.label.pageLink')}
            selected={selectedUrlView === urlViews.TITLE}
            icon={<IconWithBackground icon={() => <LinkIcon />} />}
            value={URL_VIEW.title}
            onClick={onChange}
            info={translate('card.urlAppearence.titleView.info')}
          />
          <RadioInputSection
            disabled={isContributor}
            infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
            wrapperClassName='flex-1'
            title={translate('card.urlAppearence.url.label')}
            selected={selectedUrlView === urlViews.URL}
            icon={<IconWithBackground icon={() => <LinkIcon />} />}
            value={URL_VIEW.url}
            onClick={onChange}
            info={translate('card.urlAppearence.url.info')}
          />
        </div>
      </div>
    </div>
  );
};
